<template>
  <div>
    <div v-if="isLoading" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <div class="container-fluid overflow-auto">
      <div class="row">
        <div class="col-12 pt-3 pb-3 pl-4">
          <h3><i class="fa fa-user-circle"></i> Histórico de Atendimentos</h3>
        </div>
        <div class="row col-12 pt-3 pb-3 pl-4 d-flex flex-wrap">
          <div class="col-12 col-md-2">
            <label style="font-size: 17px;">Tipos de Finalização</label>
            <b-form-select id="tipo-select" v-model="typeFinalization" :options="tipos" required></b-form-select>
          </div>
          <div class="col-12 col-md-4">
            <label style="font-size: 17px;">Data de Inicio</label>
            <b-form-input type="date" v-model="startDate" />
          </div>
          <div class="col-12 col-md-4">
            <label style="font-size: 17px;">Data de Fim</label>
            <b-form-input type="date" v-model="endDate" />
          </div>
          <div class="col-12 col-md-2 d-flex justify-content-center" style="margin-top: 25px;">
            <defaultbutton
                class="defaultbutton col-10"
                :onClick="() => getConversations()"
                btnVariant="btn-third"
                icon="fas fa-search"
                text="Filtrar"
            />
          </div>
        </div>

      </div>
      <div class="row" v-if="localConversations && localConversations.length > 0">
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3 " v-for="conversation in localConversations" :key="conversation.conversationId">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-12 photo text-center">
                            <img :src="getAvatar(conversation.photo)" alt="" />
                          </div>
                          <div class="col-12 text-center name" :title="getDisplayName(conversation)">
                            {{ getDisplayName(conversation) }}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 details">
                            <label for="Telefone"> {{ isAssociate(conversation) ? 'É Cooperado' : 'Não é Cooperado' }}</label>
                            <br/>
                            <label for="Aberto"><strong>Aberto em: </strong> {{ formatDate(conversation.createdAt) }}</label>
                          </div>
                        </div>
                      </div>
                </div>
              </div>
              <div class="flip-card-back">
                <div class="card">
                  <div class="card-body">
                    <div class="titleDetails">
                        Detalhes da Finalização
                    </div>
                    <div class="details">
                        <label for="title"><strong>Motivo de Finalização:</strong> {{conversation.finalization.type}}</label>
                        <br/>
                        <label for="title"><strong>Atendente(s):</strong></label>
                        <label>{{conversation.nameOperator }}</label>
                        <div v-if="getResponsibles(conversation) != ''">
                          <div @click="openShowResponsibles(conversation.conversationId)">
                            <div class="buttonResponsibles">
                              <i v-if="showResponsibles" class="fas fa-minus"></i>
                              <i v-else class="fas fa-plus"></i>
                            </div>
                            <label v-show="showResponsibles">{{getResponsibles(conversation)}}</label>
                          </div>
                        </div>
                        <label for="title"><strong>Finalizado em: </strong> {{formatDay(conversation.finalization.dateFinalization)}},{{formatTime(conversation.finalization.dateFinalization)}}</label>
                        <div v-if="conversation.finalization.observation != ''">
                          <label data-toggle="tooltip" data-placement="top" :title="conversation.finalization.observation" for="title"><strong>Observações:</strong> {{ conversation.finalization.observation.length > 20 ? conversation.finalization.observation.slice(0, 20) + '...' : conversation.finalization.observation }}</label>
                        </div>
                        <label for="title"><strong>Tempo de Atendimento: </strong>{{ getDuration(conversation) }}</label>
                        <br/>
                        <label for="title"><strong>Tempo de Espera: </strong>{{ getTimeInWait(conversation) }}</label>
                        <br/>
                        <label for="title"><strong>Assumido em: </strong> {{ formatDay(conversation.assumbleAt)}},{{formatTime(conversation.assumbleAt) }} </label>
                        <div class="msgButton col-12 d-flex justify-content-center">
                          <defaultbutton
                            class="defaultbutton col-10"
                            :onClick="() => openAttachModalMessages(conversation.conversationId)"
                            btnVariant="btn-third"
                            icon="fas fa-comments"
                            text="Mensagens"
                          />
                        </div>
                        <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal centered v-model="showModalMessages" ref="messages-history">
      <div class="col-12 pt-3 pb-3 pl-4">
          <h3><i class="fa fa-comments"></i> Mensagem</h3>
        </div>
      <div class="modal-content">
        <ChatMessages v-show="showModalMessages" ref="chatMessages" :messages="messages" />
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-third btn-sm" v-on:click="showModalMessages = false"  v-b-tooltip.hover
            :title="'OK'"><i class="fa "></i><span class="d-md-down-none">Ok</span></button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ConversationsSearch from './ConversationsSearch.vue'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import AccountMixin from '@/store/module/account/mixin'
import ChatMessages from '@/views/private/atendimento/historico_atendimento/components/chat/ChatMessages.vue'
import defaultbutton from '@/components/UI/button/defaultButton.vue'

import _ from 'lodash'

export default {
  name: 'Messages',
  components: {
    ConversationsSearch,
    ChatMessages,
    defaultbutton
  },
  props: {
    conversations: {
      type: Array,
      required: true
    }
  },
  mixins: [AccountMixin],
  person: {
    type: Object,
    required: false,
    default: () => null
  },
  data () {
    return {
      localConversations: [],
      isLoading: false,
      searchText: '',
      showModalTransfer: false,
      showModalMessages: false,
      typeFinalization: null,
      showResponsibles: false,
      startDate: null,
      messages: [],
      endDate: null,
      tipos: []
    }
  },
  async mounted () {
    this.addDetailsConversation()
  },
  created () {
    this.getTiposFinalizacao()
  },
  computed: {
    filteredConversations () {
      return this.conversations.filter(conversation => {
        return conversation.name.toLowerCase().includes(this.searchText.toLowerCase()) || conversation.conversationId.toString().toLowerCase().includes(this.searchText.toLowerCase()) || conversation.identifier.toString().toLowerCase().includes(this.searchText.toLowerCase().replace(/\D/g, ''))
      })
    }
  },
  watch: {
    isLoading (newValue) {
      this.$emit('loading-changed', newValue)
    },
    conversations: {
      handler () {
        this.addDetailsConversation()
      },
      deep: true
    }
  },
  methods: {
    getAvatar (encodedImage) {
      if (encodedImage) {
        return `data:image/png;base64,${encodedImage}`
      }

      return '/static/img/avatars/03.png'
    },
    async getTiposFinalizacao () {
      await AtendimentoRepository.GetTipos()
        .then(response => {
          const { data } = response
          console.log(data)
          this.tipos = data.tipos.map(tipo => ({ text: tipo, value: tipo }))
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
        })
    },
    formatDay (isoString) {
      const date = new Date(isoString)
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
    },
    formatTime (isoString) {
      const date = new Date(isoString)
      return `${date.getHours()}h:${date.getMinutes()}m:${date.getSeconds()}s`
    },
    async openShowResponsibles (conversationId) {
      await Promise.all([
        this.responsibles = this.getResponsibles(conversationId)
      ])
      if (this.showResponsibles) {
        this.showResponsibles = false
      } else { this.showResponsibles = true }
    },
    async openAttachModalMessages (conversationId) {
      await Promise.all([
        this.messages = this.getMessages(conversationId)
      ])
      this.showModalMessages = true
    },
    formatDocument (document) {
      if (!document) {
        return 'Usuário não possui documento'
      }

      let formattedDocument = document
      let documentType = ''

      if (document.length === 11) {
        formattedDocument = document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
        documentType = 'CPF '
      } else if (document.length === 14) {
        formattedDocument = document.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
        documentType = 'CNPJ '
      }

      return documentType + formattedDocument
    },
    formatDate (date) {
      let d = new Date(date)
      return d.toLocaleDateString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
    },
    async addDetailsConversation () {
      this.isLoading = true
      for (let i = 0; i < this.conversations.length; i++) {
        const conversation = this.conversations[i]
        const personDetails = await this.getDetails(conversation)
        this.localConversations.push({ ...conversation, personDetails })
      }
      this.localConversations.sort((b, a) => new Date(b.createdAt) - new Date(a.createdAt))
      this.isLoading = false
    },
    async getDetails (conversation) {
      if (conversation.personDetails) {
        return conversation.personDetails
      }
      try {
        let response = await AtendimentoRepository.GetPersonDetails(conversation.conversationId, { params: { phone: conversation.formattedPhone } })
        const { status, data } = response

        if (status === 200 && !_.isNil(data) && !_.isEmpty(data)) {
          console.log(data)
          return data
        } else {
          this.isLoading = false
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async getConversations () {
      const startIso = this.startDate ? new Date(this.startDate).toISOString() : null
      const endIso = this.endDate ? new Date(this.endDate).toISOString() : null
      console.log(startIso, endIso)
      const requestConfig = {
        params: {
          status: 'Finalizado',
          operatorId: 'all',
          startDate: startIso,
          endDate: endIso,
          typeFinalization: this.typeFinalization
        }
      }
      const pa = this.getPa()
      if (pa) {
        requestConfig.params.deptoId = pa
      }
      await AtendimentoRepository.GetConversations(requestConfig)
        .then(response => {
          const { status, data } = response

          if (status === 200) {
            console.log(data)
            this.localConversations = data
          }
        })
        .catch(error => {
          console.error(error)
        })
    },
    async getMessages (conversationId) {
      if (conversationId !== null) {
        await AtendimentoRepository.GetConversationMessages(conversationId)
          .then(response => {
            const { data } = response
            let messages = []

            if (data && data.length > 0) {
              messages = data
                .map((message, index) => {
                  return {
                    ...message,
                    sent: true,
                    order: index
                  }
                })
            }
            this.messages = messages
          })
          .catch(error => {
            console.error(error)
          })
      }
    },
    getPa () {
      // Verifica se `account`, `funcionario`, e `paId` existem antes de tentar acessar `paId[0]`
      if (this.account && this.account.funcionario) {
        if (this.account.funcionario.paId) {
          return this.account.funcionario.paId[0]
        }
      }
      // Retorna um valor padrão ou null se as condições acima não forem atendidas
      return 'all'
    },
    isAssociate (conversation) {
      return conversation.name.origem === 'Pessoa'
    },
    getDisplayName (conversation) {
      let name = 'Usuário não possui nome'
      if (conversation.name.nome) {
        name = conversation.name.nome
      }
      return name
    },
    getDuration (conversation) {
      const startDate = new Date(conversation.createdAt)
      const endDate = new Date(conversation.finalization.dateFinalization)
      const duration = endDate - startDate

      const durationInSeconds = Math.floor(duration / 1000)

      const hours = Math.floor(durationInSeconds / 3600)
      const minutes = Math.floor((durationInSeconds % 3600) / 60)
      const seconds = durationInSeconds % 60

      return `${hours}h:${minutes}m:${seconds}s`
    },
    getResponsibles (conversation) {
      let responsibles = 'Não possui responsáveis'
      if (conversation.responsibles && conversation.responsibles.length > 0) {
        responsibles = conversation.responsibles.join(', ')
        const uniqueResponsibles = [...new Set(conversation.responsibles)]
        responsibles = uniqueResponsibles.join(', ')
      }
      return responsibles
    },
    getTimeInWait (conversation) {
      let timeInWait = ''

      if (conversation.timeInWait !== undefined && conversation.timeInWait !== null) {
        let milissegundos = conversation.timeInWait

        let segundosTotal = Math.floor(milissegundos / 1000)
        let horas = Math.floor(segundosTotal / 3600)
        let minutos = Math.floor((segundosTotal % 3600) / 60)
        let segundos = segundosTotal % 60

        timeInWait += `${horas.toString().padStart(2, '0')}h:${minutos.toString().padStart(2, '0')}m:${segundos.toString().padStart(2, '0')}s`
      } else {
        timeInWait += '0s'
      }

      return timeInWait
    }
  }
}
</script>
<style lang="scss" scoped>
.container-fluid {
  height: 100%;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: #0BACA0 transparent;
}
.flip-card {
  max-width: 400px;
  height: 200px;
  margin-bottom: 20px;
  margin-right: 10px;
  perspective: 1000px;
  transition: 0.3s;
}
.card {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  overflow:auto;
  scrollbar-width: thin;
  scrollbar-color: #0BACA0 transparent;

  scrollbar-width: thin;
  scrollbar-color: #0BACA0 transparent;

  ::-webkit-scrollbar-track {
      background-color: #E3E8EF;
      border-radius: 16px;
  }

  ::-webkit-scrollbar-thumb {
      background-color: #0BACA0;
      border-radius: 16px;
  }
    white-space: normal;
  }

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}
.card-flip-front {
  max-height: 207px;
  min-height: 207px;
  max-width: 100%;
}
.titleDetails {
font-size: 17px;
font-weight: bold;
color: #1BACA0;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
}

.name {
  font-size: 17px;
  font-weight: bold;
  color: #0BACA0;
  margin-top: 7px;
}
.photo img {
  width: 80px;
  height: 80px;
  border-radius: 100%;
  border: 1px solid #01d6bd;
}
.buttonResponsibles {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-back {
  transform: rotateY(180deg);
  /* :hover {
    cursor: pointer;
  } */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.modal-content {
  width: 100%;
  height: 400px;
  overflow-y: auto;
}
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left: 4px solid #1BACA0;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/historico_atendimento/components/conversations/Conversations.vue